import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { StorageService, LocalStorageKey } from '../services/storage.service';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const storage = inject(StorageService);

  const isLoggedIn = storage.hasLocal(LocalStorageKey.Token);

  if (isLoggedIn) {
    return true;
  } else {
    router.navigate(['auth/login']);
    return false;
  }
};
